import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import i18n from '@/i18n'
import '@/sass/overrides.sass'
import '@/sass/hrvec-theme.scss'

Vue.use(Vuetify)

// พาเลตต์หลักของระบบ: แดงอาชีวศึกษา / ขาว / ดำ-เทา — สีอื่นใช้เฉพาะความหมายของสถานะเท่านั้น
// (สำเร็จ = เขียวเข้ม, เตือน = อำพัน, ผิดพลาด = แดง) ห้ามเพิ่มโทนม่วง/ชมพู/ฟ้าสดกลับเข้ามา
// ค่าเดียวกันนี้ประกาศเป็น CSS variable ใน src/sass/hrvec-theme.scss ด้วย (แก้ทั้งสองที่ให้ตรงกัน)
const theme = {
  primary: '#B3151B',
  secondary: '#424242',
  accent: '#8E1014',
  info: '#455A64',
  success: '#2E7D32',
  warning: '#A86400',
  error: '#C62828',
  deep: '#8E1014',
}

export default new Vuetify({
  lang: {
    t: (key, ...params) => i18n.t(key, params),
  },
  theme: {
    themes: {
      dark: theme,
      light: theme,
    },
  },
})
